import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.sm};
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm};
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LCol = styled(Col)`
  justify-self: start;
`;
export const RCol = styled(Col)`
  justify-self: end;
`;
